var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.179,
    height: 36.673,
    viewBox: "0 0 44.179 36.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-upload-cloud",
    "data-name": "Icon feather-upload-cloud",
    transform: "translate(1.507 1.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12040",
    "data-name": "Path 12040",
    d: "M26.965,25.482,19.482,18,12,25.482",
    transform: "translate(1.104 -1.169)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12041",
    "data-name": "Path 12041",
    d: "M18,18V34.835",
    transform: "translate(2.587 -1.169)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12042",
    "data-name": "Path 12042",
    d: "M37.773,33.288A9.353,9.353,0,0,0,33.3,15.723H30.945a14.965,14.965,0,1,0-25.7,13.655",
    transform: "translate(-1.492 -4.503)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12043",
    "data-name": "Path 12043",
    d: "M26.965,25.482,19.482,18,12,25.482",
    transform: "translate(1.104 -1.169)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3943a0f88058ae3a69d8b72fe6f29b5f.svg";
export { ForwardRef as ReactComponent };